import { useState, useEffect, useRef } from 'react';

function generateDelays(count = 10) {
  return Array.from({ length: count }, () => {
    const isTenSeconds = Math.random() < 0.4;
    return isTenSeconds ? 10000 : 5000;
  });
}

export default function AnimatedLogo({ className = '' }) {
  const [isAnimated, setIsAnimated] = useState(false);
  const timeoutsRef = useRef([]);

  useEffect(() => {
    const delays = generateDelays(10);
    let accumulated = 0;
    let animated = false;

    delays.forEach((delay) => {
      accumulated += delay;
      const timeoutId = setTimeout(() => {
        animated = !animated;
        setIsAnimated(animated);
      }, accumulated);
      timeoutsRef.current.push(timeoutId);
    });

    return () => {
      timeoutsRef.current.forEach(clearTimeout);
      timeoutsRef.current = [];
    };
  }, []);

  return (
    <img
      src={isAnimated ? '/assets/neon/logo-animado.png' : '/assets/neon/logo-fijo.png'}
      alt="NEON Music Cocktail"
      className={className}
    />
  );
}
